import api from '../../api/axios';

export const VOICE_TOGGLE_REQUEST = 'VOICE_TOGGLE_REQUEST';
export const VOICE_TOGGLE_SUCCESS = 'VOICE_TOGGLE_SUCCESS';
export const VOICE_TOGGLE_FAILURE = 'VOICE_TOGGLE_FAILURE';
export const VOICE_RESET = 'VOICE_RESET';

export const toggleVoiceMode = (textOnly) => async (dispatch) => {
  dispatch({ type: VOICE_TOGGLE_REQUEST });
  
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    // Call API to toggle voice mode
    const response = await api.post(`conversations/textOnlyModeOnOff`, {
      textOnly: textOnly
    }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    const envelope = response?.data || {};
    if (envelope.success) {
      dispatch({
        type: VOICE_TOGGLE_SUCCESS,
        payload: { 
          textOnly: envelope.data?.textOnly || textOnly,
          message: envelope.message || 'Voice mode updated successfully'
        }
      });
      return { 
        success: true, 
        textOnly: envelope.data?.textOnly || textOnly,
        message: envelope.message || 'Voice mode updated successfully'
      };
    } else {
      throw new Error(envelope.message || 'Failed to toggle voice mode');
    }
  } catch (error) {
    dispatch({
      type: VOICE_TOGGLE_FAILURE,
      error: error.message || 'Failed to toggle voice mode'
    });
    return { success: false, error: error.message };
  }
};

export const resetVoiceState = () => ({
  type: VOICE_RESET
});
